import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../..";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import classes from "./AuthorizationForm.module.css";

const AuthForm = observer(() => {
  const { store } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (store.isAuth) {
      const to = location.state?.from?.pathname || "/";
      navigate(to, { replace: true });
    }
  }, [store.isAuth, navigate, location.state]);

  const handleUsernameChange = (e) => {
    store.setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    store.setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    store.logIn();
  };

  return (
    <div className={classes.auth_form_container}>
      <CContainer>
        <CRow className="justify-content-center">
          <CCol xs={12} sm={10} md={7} lg={5} xl={4}>
            <CCard className={classes.auth_card}>
              <CCardHeader className={classes.auth_header}>Вход</CCardHeader>
              <CCardBody>
                <CForm onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <CFormLabel htmlFor="username">Логин</CFormLabel>
                    <CFormInput
                      type="text"
                      id="username"
                      value={store.username}
                      onChange={handleUsernameChange}
                      autoComplete="username"
                      disabled={store.isLoading}
                    />
                  </div>
                  <div className="mb-3">
                    <CFormLabel htmlFor="password">Пароль</CFormLabel>
                    <CFormInput
                      type="password"
                      id="password"
                      value={store.password}
                      onChange={handlePasswordChange}
                      autoComplete="current-password"
                      disabled={store.isLoading}
                    />
                  </div>

                  {store.error ? (
                    <CAlert color="danger" className="py-2">
                      {store.error}
                    </CAlert>
                  ) : null}

                  <CButton
                    color="primary"
                    type="submit"
                    className="w-100"
                    disabled={store.isLoading}
                  >
                    {store.isLoading ? (
                      <>
                        <CSpinner size="sm" className="me-2" />
                        Входим…
                      </>
                    ) : (
                      "Войти"
                    )}
                  </CButton>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
});

export default AuthForm;